"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var RenderProp = _interopRequireWildcard(require("../utils/propTypes/renderProp"));

var _UIFlex = _interopRequireDefault(require("../layout/UIFlex"));

var _UIBox = _interopRequireDefault(require("../layout/UIBox"));

var _Style = require("../core/Style");

var _sizes = require("HubStyleTokens/sizes");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-left: -", ";\n  margin-top: -", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding-left: ", ";\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Outer = (0, _styledComponents.default)(function (props) {
  var __orientation = props.orientation,
      rest = (0, _objectWithoutProperties2.default)(props, ["orientation"]);
  return _react.default.createElement("div", rest);
}).withConfig({
  displayName: "UISplitLayout__Outer",
  componentId: "sc-1nnwtln-0"
})(_templateObject(), (0, _Style.remCalc)(_sizes.BASE_SPACING_X));
var Inner = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "UISplitLayout__Inner",
  componentId: "sc-1nnwtln-1"
})(_templateObject2(), (0, _Style.remCalc)(_sizes.BASE_SPACING_X), (0, _Style.remCalc)(_sizes.BASE_SPACING_Y));
var getSlotPadding = "\n  padding-left: " + (0, _Style.remCalc)(_sizes.BASE_SPACING_X) + ";\n  padding-top: " + (0, _Style.remCalc)(_sizes.BASE_SPACING_Y) + ";\n";
var PrimarySlot = (0, _styledComponents.default)(function (props) {
  var __orientation = props.orientation,
      rest = (0, _objectWithoutProperties2.default)(props, ["orientation"]);
  return _react.default.createElement(_UIBox.default, rest);
}).withConfig({
  displayName: "UISplitLayout__PrimarySlot",
  componentId: "sc-1nnwtln-2"
})(_templateObject3(), getSlotPadding);
var SecondarySlot = (0, _styledComponents.default)(function (props) {
  var __orientation = props.orientation,
      rest = (0, _objectWithoutProperties2.default)(props, ["orientation"]);
  return _react.default.createElement(_UIBox.default, rest);
}).withConfig({
  displayName: "UISplitLayout__SecondarySlot",
  componentId: "sc-1nnwtln-3"
})(_templateObject4(), getSlotPadding);

var _default = _react.default.createClass({
  displayName: "UISplitLayout",
  propTypes: {
    InnerWrapper: RenderProp.getPropType(_UIFlex.default),
    orientation: _react.PropTypes.oneOf(['horizontal', 'vertical']),
    Primary: RenderProp.getPropType(_UIBox.default),
    primaryContent: _react.PropTypes.node.isRequired,
    primaryClassName: _react.PropTypes.string,
    primaryWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    reverseOrder: _react.PropTypes.bool.isRequired,
    Secondary: RenderProp.getPropType(_UIBox.default),
    secondaryContent: _react.PropTypes.node,
    secondaryClassName: _react.PropTypes.string,
    secondaryWidth: _react.PropTypes.number,
    width: _react.PropTypes.number
  },
  getDefaultProps: function getDefaultProps() {
    return {
      InnerWrapper: Inner,
      Primary: PrimarySlot,
      Secondary: SecondarySlot,
      orientation: 'horizontal',
      reverseOrder: false
    };
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        InnerWrapper = _this$props.InnerWrapper,
        orientation = _this$props.orientation,
        Primary = _this$props.Primary,
        primaryContent = _this$props.primaryContent,
        primaryClassName = _this$props.primaryClassName,
        primaryWidth = _this$props.primaryWidth,
        reverseOrder = _this$props.reverseOrder,
        Secondary = _this$props.Secondary,
        secondaryContent = _this$props.secondaryContent,
        secondaryClassName = _this$props.secondaryClassName,
        secondaryWidth = _this$props.secondaryWidth,
        width = _this$props.width,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "InnerWrapper", "orientation", "Primary", "primaryContent", "primaryClassName", "primaryWidth", "reverseOrder", "Secondary", "secondaryContent", "secondaryClassName", "secondaryWidth", "width"]);
    var computedDirection = orientation === 'horizontal' ? 'row' : 'column';
    return _react.default.createElement(Outer, (0, _extends2.default)({}, rest, {
      className: className,
      orientation: orientation,
      width: width
    }), _react.default.createElement(InnerWrapper, {
      direction: computedDirection,
      justify: "between",
      wrap: "wrap"
    }, _react.default.createElement(Primary, {
      className: primaryClassName,
      basis: primaryWidth,
      orientation: orientation,
      order: reverseOrder ? 1 : 0
    }, primaryContent), _react.default.createElement(Secondary, {
      basis: secondaryWidth,
      className: secondaryClassName,
      orientation: orientation
    }, secondaryContent)));
  }
});

exports.default = _default;
module.exports = exports.default;